<template>
  <div>
    <div class="box-save-minus">
      <div class="typeface-size" v-if="titleShow" :style="{ fontSize: fontSize + 'px' }">
        第 {{ CheckNum }} 题 (多项选择题)
      </div>
      <div class="font-size-save-minus" v-if="false">
        <el-button size="small" @click="increaseFontSize">+</el-button>
        <span>{{ text }}</span>
        <el-button size="small" @click="decreaseFontSize">-</el-button>
      </div>
    </div>
    <!-- <div class="name" v-if="titleShow">第 {{ CheckNum }} 题 (多项选择题)</div> -->
<!--    <div class="name" :style="{ fontSize: fontSize + 'px' }">{{ CheckContent }}</div>-->
    <div class="name" :style="{ fontSize: fontSize + 'px' }" v-html="CheckContent"></div>
    <el-checkbox-group v-model="checkList" @change="handler">
      <el-checkbox
        :style="radioLabelStyle"
        v-for="(item, index) in CheckList"
        :key="index"
        :label="item.title"
        :value="item.title"
        >{{ item.title }}. {{ item.answer }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>
<script>
export default {
  props: {
    fontSize: {
      type: Number,
      require: true,
      default: 16,
    },
    titleShow: {
      type: Boolean,
      require: false,
      default: true,
    },
    CheckNum: {
      type: Number,
      require: true,
      default: 0,
    },
    CheckContent: {
      type: String,
      require: true,
    },
    CheckList: {
      type: Array,
      require: true,
      default: [],
    },
    dataId: {
      type: String | Number,
      require: true,
    },
    dataSonId: {
      type: String | Number,
      require: true,
    },
    currentAnswer: {
      type: Array,
    },
  },
  watch: {
    currentAnswer: {
      handler(val) {
        if (!val) return;
        this.checkList = val;
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      checkList: [],
      text: "字号",
      fontSize: 16, // 初始字体大小
    };
  },
  computed: {
    radioLabelStyle() {
      return { fontSize: this.fontSize + "px" };
    },
  },
  methods: {
    onSubmit() {
      return { No: this.CheckNum, answer: this.checkList, dataId: this.dataId };
    },
    handler(e) {
      this.$emit(
        "change",
        {
          No: this.CheckNum,
          answer: e,
          dataId: this.dataId,
          dataSonId: this.dataSonId,
        },
        this.dataId
      );
    },
    increaseFontSize() {
      if (this.fontSize == 28) {
        this.$message({
          message: "已达到最大值",
          type: "warning",
        });
      } else {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize == 10) {
        this.$message({
          message: "已达到最小值",
          type: "warning",
        });
      } else {
        this.fontSize -= 2;
      }
    },
  },
};
</script>
<style scoped>
.box-save-minus {
  height: 50px;
}
.typeface-size {
  float: left;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
}
.font-size-save-minus {
  font-family: 思源黑体;
  float: right;
}
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.el-checkbox {
  margin-top: 10px;
}
.el-checkbox >>> .el-checkbox__label {
  padding-left: 24px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  /* font-size: 24px; */
  font-size: inherit;
}
.el-checkbox >>> .el-checkbox__inner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid rgb(64, 112, 179);
  /* border-radius: 50%; */
}
.el-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgb(64, 112, 179);
}
.el-checkbox >>> .el-checkbox__inner::after {
  height: 18px;
  position: absolute;
  top: -5px;
  left: 0px;
  width: 12px;
}
.name {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/topicCheck.vue